export const convertArrayFieldsToString = (obj) => {
  if (!obj || typeof obj !== "object") return obj;

  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = Array.isArray(obj[key]) ? obj[key].join(",") : obj[key];
    return acc;
  }, {});
};

export const formatIndividualIdsPayload = (individualIds) => {
  const idKeys = [
    "HealthId",
    "Pan",
    "VoterID",
    "DrivingLicense",
    "SECC",
    "NPR",
    "uhcId",
    "HealthIdAlias",
  ];

  if (!individualIds) {
    return Object.fromEntries(idKeys.map((k) => [k, null]));
  }

  let hasAny = false;
  const formatted = {};

  idKeys.forEach((key) => {
    const val = individualIds[key]?.idValue?.trim();

    if (val) {
      hasAny = true;
      formatted[key] = {
        idValue: val,
        maskedValue: individualIds[key]?.maskedValue || null,
      };
    } else {
      formatted[key] = null;
    }
  });

  return hasAny ? formatted : Object.fromEntries(idKeys.map((k) => [k, null]));
};